import { PropsWithChildren } from 'react';
import { TBLinkType } from '../../../../../utils/mappers/link';
import { ButtonBase, Link } from '@mui/material';

const Wrapper = ({
  children,
  link,
}: PropsWithChildren<{ link?: TBLinkType }>) => {
  if (!link) return <>{children}</>;
  return (
    <ButtonBase
      component={Link}
      href={link.href}
      aria-label={link.label}
      sx={{
        textDecoration: 'none !important',
        borderRadius: 0.5,
        height: '100%',
        width: '100%',
      }}
    >
      {children}
    </ButtonBase>
  );
};

export default Wrapper;
